// extracted by mini-css-extract-plugin
export default {"OrderValue__blockFour":"style_OrderValue__blockFour__MWMwF","OrderValue__Typography":"style_OrderValue__Typography__4+bPJ"};